<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tab-wrap">
      <el-tabs v-model="page.listType" @tab-click="filterFlow">
        <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
        <el-tab-pane label="待处理" name="4"></el-tab-pane>
        <el-tab-pane label="已处理" name="2"></el-tab-pane>
        <el-tab-pane label="我收到的" name="3"></el-tab-pane>
        <el-tab-pane label="我发起的" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-area" style="padding-top: 0">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">合同名称：</div>
          <el-input
            size="mini"
            v-model="page.contractName"
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">甲方名称：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.tenantGuid"
            class="ipt-sty"
            placeholder="请选择"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">乙方名称：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.serviceTenantGuid"
            class="ipt-sty"
            placeholder="请选择"
          >
            <el-option
              v-for="item in serviceTenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? "收起筛选" : "更多筛选" }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)"
            >搜索</el-button
          >
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          ></el-col
        >
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">提交人：</div>
          <el-input
            size="mini"
            v-model="page.staffName"
            clearable
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审批状态：</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.approveState"
            class="ipt-sty"
            placeholder="请选择"
          >
            <el-option
              v-for="item in ApproveStateOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">运营经理：</div>
          <el-input
            size="mini"
            v-model="page.projectManagerName"
            clearable
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">合同编码：</div>
          <el-input
            size="mini"
            v-model="page.contractCode"
            clearable
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
      </el-row>
    </div>

    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
      <div class="button-area">
        <el-button
          size="mini"
          type="info"
          @click="addContract"
          >发起流程</el-button
        >
      </div>
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="tableHeight"
      >
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
          fixed="left"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="tenantName"
          label="甲方名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="210"
          fixed="left"
        >
          <template slot-scope="scope">{{
            scope.row.tenantName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="serviceTenantName"
          label="乙方名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="210"
          fixed="left"
        >
          <template slot-scope="scope">{{
            scope.row.serviceTenantName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="operationType"
          label="操作类型"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.operationType == '2' ? '合同作废' : '合同终止' }}</template>
        </el-table-column>
        <el-table-column
          prop="endTime"
          label="审批状态"
          header-align="center"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <a
              :class="[
                ApproveStateMap[scope.row.approveState].className,
                'btn',
              ]"
            >
              {{ ApproveStateMap[scope.row.approveState].label || "-" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="提交人"
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.staffName }}</template>
        </el-table-column>
        <el-table-column
          prop="projectManagerName"
          label="运营经理"
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{
            scope.row.projectManagerName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="signDate"
          label="签约时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{
            scope.row.signDate | getDate
          }}</template>
        </el-table-column>
        <el-table-column
          prop="validityDate"
          label="合同有效期"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope"
            ><span
              :style="{
                color:
                  !scope.row.validityDate ||
                  new Date().getTime() <=
                    new Date(scope.row.validityDate).getTime() + 86400000
                    ? ''
                    : 'red',
              }"
              >{{ scope.row.validityDate | getDate }}</span
            ></template
          >
        </el-table-column>
        <el-table-column
          prop="contractUseState"
          label="合同状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope"
            ><a
              :class="[
                ContractUseStateMap[scope.row.contractUseState].className,
                'btn',
              ]"
            >
              {{ ContractUseStateMap[scope.row.contractUseState].label || "-" }}
            </a>
            <el-popover trigger="hover" placement="top">
              <div>
                {{
                  ContractUseStateMap[scope.row.contractUseState].tips || "-"
                }}
              </div>
              <template slot="reference">
                <i class="el-icon-question ml10"></i>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="contractState"
          label="盖章合同"
          show-overflow-tooltip
          header-align="center"
          align="center"
          width="80"
        >
          <template slot-scope="scope"
            ><a
              :class="[
                StampContractMap[scope.row.contractState].className,
                'btn',
              ]"
            >
              {{ StampContractMap[scope.row.contractState].label || "-" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          prop="contractType"
          label="合同类型"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{
            scope.row.contractType | commonFilterName("合同类型")
          }}</template>
        </el-table-column>
        <el-table-column
          prop="contractContent"
          label="业务类型"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{
            scope.row.contractContentType == "1" ? "业务收入" : "业务支出"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="contractContent"
          label="业务类型内容"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">
            {{
              scope.row.contractContent
                | commonFilterName(
                  scope.row.contractContentType == "1"
                    ? "业务收入类型"
                    : "业务支出类型"
                )
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contractMoney"
          label="合同金额"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="110"
        >
          <template slot-scope="scope">{{
            scope.row.contractMoney | numDigit
          }}</template>
        </el-table-column>
        <el-table-column
          prop="contractName"
          label="合同名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{
            scope.row.contractName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="contractCode"
          label="合同编码"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{
            scope.row.contractCode || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="操作时间"
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{
            scope.row.updateTime | getTime
          }}</template>
        </el-table-column>
        <el-table-column
          prop="bank"
          width="260"
          label="操作"
          fixed="right"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <a
              class="txt-color"
              v-if="getListBtnState('detail', scope.row) == 'detail'"
              @click="editContract(scope.row, 2)"
            >
              详情
            </a>
            <a
              class="txt-color"
              @click="
                passDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
              @click="
                rejectDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              驳回
            </a>
            <a
              class="txt-color"
              @click="toRevoke(scope.row)"
              v-if="getListBtnState('revoke', scope.row) == 'revoke'"
            >
              撤销
            </a>
            <a
              class="txt-color"
              @click="editContract(scope.row, 1)"
              v-if="getListBtnState('edit', scope.row) == 'edit'"
            >
              编辑
            </a>
            <a
              class="txt-color"
              v-if="getListBtnState('del', scope.row) == 'del'"
              @click="delContract(scope.row.guid)"
            >
              删除
            </a>
            <a
              class="txt-color"
              v-if="getListBtnState('again', scope.row) == 'again'"
              @click="editContract(scope.row, 3)"
            >
              重新提交
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog
      title="驳回流程"
      :visible.sync="rejectDialogVisible"
      width="30%"
      top="15%"
    >
      <el-input
        type="textarea"
        :rows="5"
        placeholder="输入驳回理由（必填）"
        v-model="approveSuggest"
        maxlength="100"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()"
          >驳回</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="填写通过备注"
      :visible.sync="passDialogVisible"
      width="30%"
      top="15%"
    >
      <el-input
        type="textarea"
        :rows="5"
        placeholder="请填写通过备注（选填）"
        v-model="approveSuggest"
        maxlength="100"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()"
          >通过</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import workFlowCommon from "@/uilt/workFlowCommon";
import {
  ApproveStateMap,
  ApproveStateEnum,
  ApproveStateOption,
  StampContractMap,
  StampContractEnum,
  ContractUseStateMap,
  ContractUseStateEnum,
} from "./enum";
import { getContractOperationList, deleteContractOperation } from "@/api/contractOperation.js";
export default {
  components: {},
  data() {
    return {
      ApproveStateMap,
      ApproveStateEnum,
      ApproveStateOption,
      StampContractMap,
      StampContractEnum,
      ContractUseStateMap,
      ContractUseStateEnum,
      showMore: false,
      tableHeight: window.innerHeight - 310,
      contentMainHeight: window.innerHeight - 210,
      flowType: "00044",
      fullscreenLoading: false,
      currentStaffGuid: null,
      tenantList: [], //甲方
      serviceTenantList: [], //乙方
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "", //甲方
        serviceTenantGuid: "", //乙方
        staffName: "",
        contractName: "",
        approveState: ApproveStateEnum.all,
        approveStateList: [],
        projectManagerGuid: null,
        projectManagerName: "",
        isNotTask: null,
        isNotOperation: null,
        listType: "0",
        currentTenantGuid: localStorage.guid,
        isUploadContract: null,
        isRemoveInvalidity: null,
        contractState: null,
        contractUseStateList: [],
        contractCode: "",
      },
      tableLoading: false,
      tableData: [],
      right: "right",
      approveSuggest: "",
      passDialogVisible: false,
      rejectDialogVisible: false,
      form: "",
    };
  },

  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.getList(1);
    this.getTenantList();
    this.getServiceTenantList();
  },
  activated() {
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 360;
        this.contentMainHeight = window.innerHeight - 260;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 310;
        this.contentMainHeight = window.innerHeight - 210;
        return;
      }
    },
  },
  methods: {
    filterFlow() {
      this.getList();
    },
    //获取操作按钮显隐
    getListBtnState(btnType, row) {
      return workFlowCommon.getListBtnState(
        btnType,
        row.approveState,
        row.staffGuid,
        row.approveStaffGuids,
        this.currentStaffGuid,
        row.bizApproveState
      );
    },
    //获取审批状态
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    //新增
    addContract() {
      this.$router.push("/contractTerminationAdd");
    },
    //获取客户
    async getTenantList() {
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['010201', '9901', '0101'],
        bizState: 'Y'
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tenantList = data.data.records || [];
    },
    //获取乙方
    async getServiceTenantList() {
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ["9901", "9903", "9904"],
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.serviceTenantList = data.data.records;
    },
    //清空
    emptySearch() {
      this.page = {
        listType: "0",
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "", //甲方
        serviceTenantGuid: "", //乙方
        staffName: "",
        contractName: "",
        approveState: ApproveStateEnum.all,
        approveStateList: [],
        projectManagerGuid: null,
        projectManagerName: "",
        isNotTask: null,
        isNotOperation: null,
        currentTenantGuid: localStorage.guid,
        isUploadContract: null,
        isRemoveInvalidity: null,
        contractState: null,
        contractUseStateList: [],
        contractCode: "",
      };
      this.getList(1);
    },
    //type 为1编辑3重新提交 2为详情
    editContract(row, type) {
      let query = {
        guid: row.guid,
        approveStaffGuid: Array.isArray(row.approveStaffGuids)
          ? [row.approveStaffGuids]
          : null,
        camundaInstanceId: row.camundaInstanceId,
        camundaDeploymentId: row.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: row.staffGuid,
        submitStaffName: row.staffName,
        toType: type,
      };
      this.$router.push({
        path:
          type == 1 || type == 3
            ? "/contractTerminationAdd"
            : "/contractTerminationDetail",
        query,
      });
    },
    async getList(type) {
      if (type == 1) {
        this.page.pageIndex = 1;
      }
      this.tableLoading = true;
      let query = {
        ...this.page,
        listType: parseInt(this.page.listType),
      };
      const { data } = await getContractOperationList(query);
      this.tableLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tableData = data.data.records || [];
      this.page.totalPage = data.data.totalPages;
      this.page.totalRows = data.data.totalRows;
    },
    // 删除
    async delContract(guid) {
      try {
        await this.$confirm(messageConfig.DELETE_AFTER, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const { data } = await deleteContractOperation([guid]);
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.error(data.msg);
          return;
        }
        this.$message.success(messageConfig.DELETE_SUCCESS);
        this.page.pageIndex = 1;
        this.getList();
      } catch {
        this.$message({
          type: "info",
          message: "已取消操作！",
        });
      }
    },
    //驳回提交
    async toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == "") {
        this.$message.error("请填写驳回理由！");
        return;
      }
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.rejectDialogVisible = false;
      this.$message.success(messageConfig.FLOW_REJECT);
      this.getList();
    },
    //通过
    async toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.passDialogVisible = false;
      this.$message.success(messageConfig.FLOW_PASS);
      this.getList();
    },
    //撤销
    async toRevoke(row) {
      try {
        await this.$confirm(messageConfig.FLOW_IS_CANCEL, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        let query = {
          guid: row.approveGuid,
          flowType: this.flowType,
          approveStaffGuid: row.staffGuid,
        };
        this.fullscreenLoading = true;
        const { data } = await this.api.postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`,
          query
        );
        this.fullscreenLoading = false;
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.error(data.msg);
          return;
        }
        this.$message.success(messageConfig.FLOW_CANCEL);
        this.getList();
      } catch {
        this.$message({
          type: "info",
          message: "已取消操作！",
        });
      }
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-6 {
  display: flex;
}
.el-col-24 {
  display: flex;
  margin-bottom: 15px;
}
.search-area-div {
  width: 90px;
  text-align: right;
}
.ipt-sty {
  flex: 1;
}
a.txt-color + a.txt-color::before {
  content: "|";
  display: inline-block;
}
.file-box .search-area-div {
  flex-shrink: 0;
  width: 140px;
  word-break: keep-all;
}
.stamped-contract {
  text-align: left;
}
.tab-wrap {
  background: #fff;
}

/deep/ .el-tabs__nav {
  margin-left: 10px;
}
.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
</style>
